<template>
  <v-container
    id="me-list"
  >

    <v-row>
      <v-col><h3><b>Medalhas</b></h3></v-col>
      <v-col
        class="text-right"
      >

        <app-modal-insert
          v-if="isAdmin"
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"

        >
          <template v-slot:title
            :edit="false"
          >
            Cadastrar Medalha
          </template>
        </app-modal-insert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >

        <template v-slot:item.imagemBlob="{ item }">
          <img v-if="imagemMedalha(item, 'imagemBlob', 'imagemBlobS3Url')" :src="imagemMedalha(item, 'imagemBlob', 'imagemBlobS3Url')" style="width: 80px;">
        </template>

        <template v-slot:item.imagemBronzeBlob="{ item }">
          <img v-if="imagemMedalha(item, 'imagemBronzeBlob', 'imagemBronzeBlobS3Url')" :src="imagemMedalha(item, 'imagemBronzeBlob', 'imagemBronzeBlobS3Url')" style="width: 80px;">
        </template>
        <template v-slot:item.imagemPrataBlob="{ item }">
          <img v-if="imagemMedalha(item, 'imagemPrataBlob', 'imagemPrataBlobS3Url')" :src="imagemMedalha(item, 'imagemPrataBlob', 'imagemPrataBlobS3Url')" style="width: 80px;">
        </template>
        <template v-slot:item.imagemOuroBlob="{ item }">
          <img v-if="imagemMedalha(item, 'imagemOuroBlob', 'imagemOuroBlobS3Url')" :src="imagemMedalha(item, 'imagemOuroBlob', 'imagemOuroBlobS3Url')" style="width: 80px;">
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-insert
                v-if="isAdmin || item.nacional != 1"
                :object="item"
                :edit="true"
                :color="'warning'"
                :icon="'mdi-pencil'"

              >
                <template v-slot:title>
                  Editar Medalha
                </template>
              </app-modal-insert>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.acoes_delete="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-delete
                    v-if="isAdmin || item.nacional != 1"
                    :object="item"

                  >
                    <template v-slot:title>
                      Deletar
                    </template>
                  </app-modal-delete>
            </v-col>

            <v-col
              cols="1"
            >
            </v-col>
          </v-row>
        </template>

        <template slot="no-data">
          <span>
            Nenhuma Medalha retornada
          </span>
        </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsert from './ModalInsert'
import { medalhaAPI } from '../API/Medalha'
import { mapActions, mapGetters } from 'vuex'
import AppModalDelete from './../components/ModalDelete'
export default {
  components: {
    AppModalInsert,
    AppModalDelete
  },
  data () {
    return {
      headers: [
        { text: 'Imagem', value: 'imagemBlob', width: '150px' },
        { text: 'Regra', value: 'temaId', width: '150px' },
        { text: 'Texto', value: 'texto', width: '150px' },
        { text: 'Titulo', value: 'titulo', width: '150px' },
        { text: 'Perguntas', value: 'perguntas', width: '150px' },
        { text: 'Imagem Bronze', value: 'imagemBronzeBlob', width: '150px' },
        { text: 'Imagem Prata', value: 'imagemPrataBlob', width: '150px' },
        { text: 'Imagem Ouro', value: 'imagemOuroBlob', width: '150px' },
        { text: 'Editar', value: 'acoes', width: '150px', sortable: false },
        { text: 'Excluir', value: 'acoes_delete', width: '150px', sortable: false }
      ],
      payload: [],
      temas: []
    }
  },
  methods: {
    ...mapActions([
      'setLoading',
      'setConsultorCondutorMunicipio',
      'setConsultorEspecialistaMunicipio',
      'setAnalistaMunicipio',
      'setADMunicipio'
    ]),
    loadTemas () {
      medalhaAPI.getTemas()
        .then(resp => {
          this.temas = resp.data
        })
        .catch()
    },
    loadMedalhas () {
      this.setLoading(true)
      medalhaAPI.list()
        .then(resp => {
          this.payload = resp.data
          this.payload.forEach(element => {
            element.temaId = this.temas.filter(item => parseInt(item.temaId) === parseInt(element.temaId)).map(item => item.nome)[0]
          })

          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter Medalhas')
        })
    },
    imagemMedalha (item, blobField, s3Field) {
      if (item[s3Field]) return item[s3Field]
      if (item[blobField]) return `data:image/jpeg;base64,${item[blobField]}`
      return ''
    }
  },
  mounted () {
    this.loadTemas()
    this.loadMedalhas()
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isConsultorCondutorMunicipio',
      'isConsultorEspecialistaMunicipio',
      'isADMunicipio',
      'isAnalistaMunicipio',
      'isAuthenticated',
      'cityId',
      'isSPFesp',
      'isSPFespEspecial',
      'isSPCoordenador'
    ])
  }
}
</script>
